var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class SubMenu extends Component {
    constructor() {
        super('SubMenu', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Scroll behavior
            let previousScrollPosition = 0;
            $(window).on('scroll', () => {
                const stopPosition = parseFloat($('body').css('--header-height')) - $('.sub-menu').height();
                const stopDetection = $('.sub-menu').height();
                if (window.scrollY > stopDetection) {
                    $('.sub-menu').addClass('is-fixed').css('top', stopPosition);
                }
                else if (window.scrollY === 0) {
                    $('.sub-menu').removeClass('is-fixed is-pulled-out has-transition').removeAttr('style');
                }
                if (window.scrollY < previousScrollPosition && window.scrollY !== 0) {
                    if (window.scrollY > stopDetection)
                        $('.sub-menu').addClass('is-pulled-out has-transition');
                }
                else {
                    $('.sub-menu').removeClass('is-pulled-out');
                }
                $('.filters').removeClass('is-opened');
                previousScrollPosition = window.scrollY;
            });
            // Mobile filters
            $('.btn-current-filter').each((button) => {
                const selectedFilter = button.next().find('.is-active');
                const text = selectedFilter.hasClass('is-all') ? '' : selectedFilter.text();
                button.text(text);
            });
            const currentSubMenuText = $('.sub-menu-row.fs-small .btn-current-filter').text();
            $('.sub-menu-row.fs-small .filters a').each((filter) => {
                if ($(window).width() >= 992)
                    return;
                if (filter.text() === currentSubMenuText)
                    filter.addClass('d-none');
            });
            this.computeFiltersHeight();
            $(window).on('resize', this.computeFiltersHeight);
            $('.btn-toggle-filter, .btn-current-filter').on('click', (event, button) => {
                event.preventDefault();
                this.computeFiltersHeight();
                const isOpened = button.parent().find('.filters').hasClass('is-opened');
                $('.filters').removeClass('is-opened');
                if (isOpened) {
                    button.parent().find('.filters').removeClass('is-opened');
                }
                else {
                    button.parent().find('.filters').addClass('is-opened');
                }
            });
            // Component initialization done
            this.success();
        });
    }
    computeFiltersHeight() {
        $('.filters').each((filterElement) => {
            let height = 0;
            filterElement.find('a').each((element) => {
                height += element.height();
            });
            filterElement.css('--height', height + 'px');
        });
    }
}
